import React, { useContext } from "react";
import { useParams } from "react-router";
import { useQuery } from "@apollo/client";
import ManagerOverview from "../../Components/Manager/ManagerOverview";
import { GET_TEAMS_BY_MANAGER_ID, TEAMS_WITH_PERMISSION } from "../../GraphQL/Teams.js";
import { GET_MANAGER, GET_MANAGERS } from "../../GraphQL/Managers.js";
import { LoginContext } from "../../Components/Login/LoginContext";
import TeamTable from "../../Components/Team/TeamTable.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import NewTeamButton from "../../Components/Team/NewTeamButton.js";
import { Typography } from "@mui/material";

const ManagerPage = () => {
  const { managerId } = useParams();

  const managers = useQuery(GET_MANAGERS, {});

  const teamsManaged = useQuery(GET_TEAMS_BY_MANAGER_ID, {
    variables: { id: managerId },
  });

  const manager = useQuery(GET_MANAGER, {
    variables: { id: managerId },
  });

  const teamsWithPermission = useQuery(TEAMS_WITH_PERMISSION, {});

  const [auth] = useContext(LoginContext);

  const queryError =
    managers.error ||
    teamsManaged.error ||
    manager.error ||
    teamsWithPermission.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          managers.refetch();
          teamsManaged.refetch();
          manager.refetch();
          teamsWithPermission.refetch();
        }}
      />
    );
  }

  if (
    teamsManaged.loading ||
    manager.loading ||
    managers.loading ||
    teamsWithPermission.loading
  )
    return <LoadingSpinner />;

  return (
    <PageLayout
      title={`Manager: ${manager.data.manager.user.username}`}
      breadcrumbs={[
        { label: "Home", to: "/" },
        { label: manager.data.manager.user.username },
      ]}
    >
      <ManagerOverview manager={manager.data.manager} />
      <Typography variant="h5" sx={{ mt: 3, mb: 1 }}>Teams</Typography>
      {auth.loggedIn && <NewTeamButton managerId={managerId} />}
      <TeamTable
        managers={managers.data.managers}
        teams={teamsManaged.data.teamsByManagerId}
        teamsWithPermission={teamsWithPermission.data.teamsWithPermission}
      />
    </PageLayout>
  );
};

export default ManagerPage;
